import React, { useState } from 'react';
import { auth } from '../utils/auth';
import { api } from '../utils/api';

interface SignupFormProps {
  onSignup: (user: any) => void;
}

const SignupForm: React.FC<SignupFormProps> = ({ onSignup }) => {
  const detectedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    timezone: detectedTimezone.includes('Los_Angeles') ? 'America/Los_Angeles' : 
              detectedTimezone.includes('New_York') ? 'America/New_York' :
              detectedTimezone.includes('Chicago') ? 'America/Chicago' :
              detectedTimezone.includes('Denver') ? 'America/Denver' :
              'America/Los_Angeles', // default fallback
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const signup_result = await api.signup(formData);
    if (signup_result.success) {
      const token = await api.signin({email: formData.email, password: formData.password});
      if (token) {
        auth.setToken(token);
        onSignup({
          name: formData.name,
          email: formData.email,
          token,
        });
      } else {
        setError('User created, but signin failed');
      }
    } else {
        setError('Signup failed');
    }
    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <input
          type="text"
          required
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          className="w-full px-3 py-2 border border-neutral-300 focus:border-neutral-500 focus:outline-none font-mono text-sm"
          placeholder="name"
        />
      </div>

      <div>
        <input
          type="email"
          required
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          className="w-full px-3 py-2 border border-neutral-300 focus:border-neutral-500 focus:outline-none font-mono text-sm"
          placeholder="email"
        />
      </div>

      <div>
        <input
          type="password"
          required
          value={formData.password}
          onChange={(e) => setFormData({ ...formData, password: e.target.value })}
          className="w-full px-3 py-2 border border-neutral-300 focus:border-neutral-500 focus:outline-none font-mono text-sm"
          placeholder="password"
        />
      </div>

      <div>
        <select
          value={formData.timezone}
          onChange={(e) => setFormData({ ...formData, timezone: e.target.value })}
          className="w-full px-3 py-2 border border-neutral-300 focus:border-neutral-500 focus:outline-none font-mono text-sm"
        >
          <option value="America/New_York">eastern</option>
          <option value="America/Chicago">central</option>
          <option value="America/Denver">mountain</option>
          <option value="America/Los_Angeles">pacific</option>
          <option value="Europe/London">london</option>
          <option value="Europe/Paris">paris</option>
          <option value="Asia/Tokyo">tokyo</option>
        </select>
      </div>

      {error && (
        <div className="p-2 border border-neutral-300 bg-neutral-50 text-xs font-mono text-neutral-700">
          {error}
        </div>
      )}

      <button
        type="submit"
        disabled={loading}
        className="w-full py-2 border border-neutral-900 bg-neutral-900 text-white font-mono text-sm hover:bg-neutral-800 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        {loading ? 'loading...' : 'join'}
      </button>
    </form>
  );
};

export default SignupForm;
